import React from 'react';

interface DateCalculatorProps {
	startDate: string
	totalHours: number
	setDateField?: (date: string) => void
}

function dateToInputString(date: Date): string {
	const day = date.getDate().toString().padStart(2, '0');
	const month = (1 + date.getMonth()).toString().padStart(2, '0');
	const year = date.getFullYear().toString().padStart(4, '0');

	return `${year}-${month}-${day}`;
}

function DateCalculator({ totalHours, ...props }: DateCalculatorProps) {
	const [weekHours, setWeekHours] = React.useState(10);

	const endDate = React.useMemo(() => {
		if (isNaN(weekHours) || !isFinite(weekHours)) return null;

		const days = Math.floor(totalHours / weekHours * 7);
		const date = new Date(props.startDate + 'T00:00:00-03:00');

		date.setDate(date.getDate() + days);
		date.setSeconds(date.getSeconds() - 1);

		if (date.getDay() === 0) {
			date.setDate(date.getDate() - 2);
		} else if (date.getDay() === 6) {
			date.setDate(date.getDate() - 1);
		}

		return dateToInputString(date);
	}, [props.startDate, totalHours, weekHours]);

	const changeWeekHoursHandler = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setWeekHours(e.target.valueAsNumber);
	}, []);

	return (
		<div className='d-flex flex-column p-2'>
			<span>Horas por semana:</span>
			<input className='mb-3' type='number' onChange={changeWeekHoursHandler} value={weekHours} />

			{endDate !== null && (
				<>
					<span>Término previsto:</span>
					<input className='mb-3' disabled type="date" value={endDate} />
				</>
			)}

			{!!props.setDateField && endDate !== null && (
				<button className='btn btn-sm btn-primary' onClick={() => props.setDateField?.(endDate)}>Ok</button>
			)}
		</div>
	);
}

DateCalculator.displayName = 'DateCalculator';

export default DateCalculator;
